import { Filter, SelectedFilterOption } from 'src/types';

export const getDefaultSelectedFilterValues = (filters: Filter[]) =>
  filters.reduce((acc: SelectedFilterOption[], { defaultOption, options, uid }: Filter) => {
    if (typeof defaultOption === 'number') {
      const newFilterOption: SelectedFilterOption = {
        selectedByDefault: true,
        filterUid: uid,
        filterOptionValue: options[defaultOption].value,
      };
      if (options[defaultOption].uid) {
        newFilterOption.filterOptionUid = options[defaultOption].uid;
      }
      return acc.concat([newFilterOption]);
    }
    return acc;
  }, []);
